/**
 * FoE - Helper (Forge of Empires helper)
 *
 * Declares a single web-accessible-resource entry (`js/*`, `vendor/*`, `css/*`,
 * `content/*`) matched to https origins with no `use_dynamic_url` — so its scripts,
 * icons and stylesheets are all fetchable from any https page at a fixed URL.
 *
 * The bundled game icons under js/web are the cleanest signal: being images they load
 * through `probeImage` with no CORS grant, so they survive a restrictive page CSP.
 *
 * Manifest verified against version 4.4.1.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bkagcmloachflbbkfmfiggipaelfamdf';

export const foeHelper: ExtensionDefinition = {
  id: ID,
  name: 'FoE - Helper',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Exposes js, vendor, css and content directories to https origins with no dynamic ' +
    'URL. The bundled game icons are conclusive and load without a CORS grant.',
  signals: [
    {
      id: 'war-unit-tab-icon',
      kind: 'web-accessible-resource',
      description:
        'Load js/web/unit/images/unit_tab_icon.png via <img> — a bundled game icon ' +
        'exposed to https origins; needs no CORS grant, so it works under a strict CSP.',
      weight: 1,
      run: () => probeImage(ID, 'js/web/unit/images/unit_tab_icon.png'),
    },
    {
      id: 'war-inject-js',
      kind: 'web-accessible-resource',
      description: 'Fetch js/inject.js — the main injected script exposed as a static WAR.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/inject.js'),
    },
    {
      id: 'war-popup-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/popup.css — the popup stylesheet, a third path independent of the ' +
        'icon and injected script.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/popup.css'),
    },
  ],
};
